module.exports = __webpack_public_path__ + "img/av-logo-white.6d9a56a1.png";